(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('banner', banner);

    /* @ngInject */
    function banner($timeout) {
        var directive = {
            bindToController: true,
            templateUrl: 'banner.tpl',
            controller: bannerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                banner: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // console.log('banner.link', scope.vm);
            scope.vm.$slideIndex = 0;
            scope.vm.nextSlide = function() {
                var total = scope.vm.banner && angular.isDefined(scope.vm.banner["banner-image"]) ? scope.vm.banner["banner-image"].length : 0;
                if(total > 0) {
                    scope.vm.$slideIndex = (scope.vm.$slideIndex == total - 1) ? 0 : scope.vm.$slideIndex + 1;
                }
                // console.log('current slide - ', scope.vm.$slideIndex);
            };
            scope.vm.play = function() {
                $timeout(function() {
                    scope.vm.nextSlide();
                    scope.vm.play();
                }, 7000);
            };
            scope.vm.play();
            scope.vm.isVpn = window.matchMedia("(max-width: 480px)").matches;
            scope.$on('throttledResize', function(e, args) {
                scope.vm.isVpn = window.matchMedia("(max-width: 480px)").matches;
            });
            var totalImages = scope.vm.banner && angular.isDefined(scope.vm.banner["banner-image"]) ? scope.vm.banner["banner-image"].length : 0;
            if(totalImages > 0) {
                if(angular.isDefined(scope.vm.banner["banner-image-mobile"])) {
                    if(totalImages > scope.vm.banner["banner-image-mobile"].length) {
                        for(var i = scope.vm.banner["banner-image-mobile"].length - 1; i < totalImages; i++) {
                            scope.vm.banner["banner-image-mobile"][i] = scope.vm.banner["banner-image"][i];
                        }
                    }
                } else {
                    scope.vm.banner["banner-image-mobile"] = scope.vm.banner["banner-image"];
                }
            }
            // scope.vm.imgSrc = function(sidx) {
            //     return scope.vm.baseurl + window.matchMedia("(max-width: 480px)").matches ?
            //         scope.vm.banner["banner-image-mobile"][sidx].image.value.url :
            //         scope.vm.banner["banner-image"][sidx].image.value.url;
            // };
        }

    }

    /* @ngInject */
    function bannerController($scope) {
        // banner-image-mobile
        // console.log('banner.bannerController', $scope.vm);
        $scope.vm.baseurl = baseurl;
        // $scope.vm.baseurl = 'http://pie.dev.limusdesign.com';
    }

})();